export default __webpack_public_path__ + "static/media/EDISON_CF-DS-release3-v09.1e0e851c.pdf";